export default __webpack_public_path__ + "static/media/baby_boomers.ecff64bf.svg";